import url from "@/config/url";

export default {
  secondsTohhmmss(secs) {
    const pad = num => (num ? ("0" + num).slice(-2) : "00");
    const minutes = Math.floor(secs / 60) % 60;
    secs = secs % 60;
    const hours = Math.floor(minutes / 60);
    // eslint-disable-next-line no-const-assign
    return pad(hours) + ":" + pad(minutes) + ":" + pad(secs);
  },
  storagePath(path) {
    return !path || path.includes("http") ? path : url.storage + path;
  },
  streams(val) {
    return val > 1 ? `${val} streams` : `${val} stream`;
  }
};
